// extracted by mini-css-extract-plugin
module.exports = {"root":"TooltipText_root__1wsR4","show":"TooltipText_show__2q_fu"};